//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
  data () {
    return {
      filter_labels: [],
      brand_categories: [],
      brands: [],
      category: '',
      language: 'en',
      search_term: '',
    }
  },

  mounted: function() {
    this.getCurrentLanguage();
    this.storeUriParameters();
    this.getBrands();
    this.getBrandCategories();
    this.getFilterLabels();

    // Get Selectpicker to function within VueJS
    const $selectpicker = $(this.$el).find('.selectpicker');

    $selectpicker.selectpicker({
      style: 'bs-dropdown',
      size: 10,
      dropupAuto : false,
    });
  },

  updated() {
    $(this.$el).find('.selectpicker').selectpicker('refresh');

    // History API Start
    var that = this;
    window.onpopstate = function() {
      that.storeUriParameters()
    }
    // History API End
  },

  methods: {
    // History API Start
    pushHistoryState() {
      window.history.pushState(null, '', '?category=' + this.category + '&keyword=' + this.search_term);
    },
    // History API End

    // Get URI Parameters Start
    storeUriParameters() {
      var category = this.getAllUrlParams().category;
      var search_term = this.getAllUrlParams().keyword;

      if (category) {
        this.category = category;
      } else {
        this.category = '';
      }

      if (search_term) {
        this.search_term = search_term;
      } else {
        this.search_term = '';
      }
    },
    // Get URI Parameters End

    getCurrentLanguage() {
      let that = this;
      var url = window.location.href;

      // By defauly, language is already en, but if url contains /mt/, change this to mt
      if (url.indexOf('/mt/') !== -1) {
        that.language = 'mt';
      }
    },

    getBrands() {
      let that = this;

      axios.get('/wp-json/wp/v2/brands?language=' + that.language)
      .then(function (response) {
        that.brands = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
    },

    getBrandCategories() {
      let that = this;

      axios.get('/wp-json/wp/v2/brand_categories')
      .then(function (response) {
        that.brand_categories = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
    },

    getFilterLabels() {
      let that = this;

      axios.get('/wp-json/wp/v2/filter_labels?language=' + that.language)
      .then(function (response) {
        that.filter_labels = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
    },

    // Get URL Parameters: https://www.sitepoint.com/get-url-parameters-with-javascript/
    getAllUrlParams(url) {

      // get query string from url (optional) or window
      var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

      // we'll store the parameters here
      var obj = {};

      // if query string exists
      if (queryString) {

        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i=0; i<arr.length; i++) {
          // separate the keys and the values
          var a = arr[i].split('=');

          // in case params look like: list[]=thing1&list[]=thing2
          var paramNum = undefined;
          var paramName = a[0].replace(/\[\d*\]/, function(v) {
            paramNum = v.slice(1,-1);
            return '';
          });

          // set parameter value (use 'true' if empty)
          var paramValue = typeof(a[1])==='undefined' ? true : a[1];

          // (optional) keep case consistent
          paramName = paramName.toLowerCase();
          paramValue = paramValue.toLowerCase();

          // if parameter name already exists
          if (obj[paramName]) {
            // convert value to array (if still string)
            if (typeof obj[paramName] === 'string') {
              obj[paramName] = [obj[paramName]];
            }
            // if no array index number specified...
            if (typeof paramNum === 'undefined') {
              // put the value on the end of the array
              obj[paramName].push(paramValue);
            }
            // if array index number specified...
            else {
              // put the value at that index number
              obj[paramName][paramNum] = paramValue;
            }
          }
          // if param name doesn't exist yet, set it
          else {
            obj[paramName] = paramValue;
          }
        }
      }

      return obj;
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/brands.vue